import React from 'react';
import { Card, OverlayTrigger } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUp, faArrowDown, faChevronRight } from '@fortawesome/pro-regular-svg-icons';
import classnames from 'classnames';

import Info from '../../../../components/Info';

import style from './style.module.scss';

const OverlayTriggerWrapper = ({ children, overlay, placement = 'left' }) => {
  if (overlay) {
    return (
      <OverlayTrigger
        overlay={overlay}
        placement={placement}
        trigger="click"
        rootClose
      >
        {children}
      </OverlayTrigger>
    );
  }

  return children;
};

const OverviewContainer = ({
  title,
  description,
  value,
  icon,
  variant,
  previousValue,
  cardPlacement,
  children,
}) => {
  const percentage = ((value - previousValue) / previousValue) * 100;
  const styleClass = percentage >= 0 ? style.green : style.red;

  return (
    <Card className={style.OverviewContainer}>
      <div className={classnames(style.Icon, style[variant])}>
        <FontAwesomeIcon icon={icon} />
      </div>
      <OverlayTriggerWrapper overlay={children} placement={cardPlacement}>
        <div
          className="d-flex flex-grow-1 align-items-center justify-content-between ml-3"
          style={{ cursor: children ? 'pointer' : 'inherit' }}
        >
          <div className={style.DataContainer}>
            <div className="d-flex">
              <span className={style.DataValue}>{value}</span>
              {!Number.isNaN(percentage) && Number.isFinite(percentage) && (
                <div className={classnames(style.PercentageContainer, styleClass)}>
                  <div className={classnames(style.IconContainer, styleClass)}>
                    <FontAwesomeIcon
                      className={style.PercentageIcon}
                      icon={percentage >= 0 ? faArrowUp : faArrowDown}
                    />
                  </div>
                  <span className={style.DataPercentage}>{`${percentage.toFixed(0)}%`}</span>
                </div>
              )}
            </div>
            <span className={style.DataTitle}>{title}</span>
          </div>
          {children && <FontAwesomeIcon icon={faChevronRight} />}
        </div>
      </OverlayTriggerWrapper>
      {description && (
        <div className={style.InfoTrigger}>
          <Info content={description} position="bottom" />
        </div>
      )}
    </Card>
  );
};

export default OverviewContainer;
